import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { RemediationSnapshot, RemediationSnapshotSummary } from '#models';

@Injectable({ providedIn: 'root' })
export class RemediationSnapshotService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1/remediations`;

    getByRemediation(remediationId: string): Observable<RemediationSnapshotSummary[]> {
        return this._http.get<RemediationSnapshotSummary[]>(`${this._base}/${remediationId}/snapshots`);
    }

    getById(remediationId: string, snapshotId: string): Observable<RemediationSnapshot> {
        return this._http.get<RemediationSnapshot>(`${this._base}/${remediationId}/snapshots/${snapshotId}`);
    }

    takeSnapshot(remediationId: string, snapshotNote?: string): Observable<RemediationSnapshot> {
        return this._http.post<RemediationSnapshot>(`${this._base}/${remediationId}/snapshots`, { snapshotNote });
    }

    delete(remediationId: string, snapshotId: string): Observable<void> {
        return this._http.delete<void>(`${this._base}/${remediationId}/snapshots/${snapshotId}`);
    }
}
